import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchFilterComponent } from './search-filter.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { OperationTypeFilterModule } from './components/operation-type-filter/operation-type-filter.module';
import { PropertyTypeFilterModule } from './components/property-type-filter/property-type-filter.module';
import { CharacteristicsTypeFilterModule } from './components/characteristics-type-filter/characteristics-type-filter.module';
import { AreaTypeFilterModule } from './components/area-type-filter/area-type-filter.module';
import { ValueTypeFilterModule } from './components/value-type-filter/value-type-filter.module';
import { MoreTypeFilterModule } from './components/more-type-filter/more-type-filter.module';
import {SearchFilterService} from './search-filter.service';

@NgModule({
    imports: [
        CommonModule,
        NgZorroAntdModule,
        OperationTypeFilterModule,
        PropertyTypeFilterModule,
        CharacteristicsTypeFilterModule,
        AreaTypeFilterModule,
        ValueTypeFilterModule,
        MoreTypeFilterModule
    ],
    declarations: [ SearchFilterComponent ],
    exports: [ SearchFilterComponent ],
    providers: [SearchFilterService]
})
export class SearchFilterModule { }
